import { trackEvent } from '@Services/analytics/tracking.service.ts';
import { useEffect } from 'react';

export const useVerificationCenterAnalytics = () => {
  useEffect(() => {
    trackEvent('Enter Verification Center');
  }, []);

  function reportActOnVerificationCenter(action: string): void {
    trackEvent('Act on Verification Center', { action });
  }

  function reportErrorDuringFileUpload(
    errorCode: string,
    httpStatus: number,
    errorMessage: string
  ): void {
    trackEvent('Error During file upload', { errorCode, httpStatus, errorMessage });
  }

  return {
    reportActOnVerificationCenter,
    reportErrorDuringFileUpload,
  };
};
